export class Formulario {
    public static foiAlterado(valoresIniciais: any, valoresAtuais: any): boolean {
        return JSON.stringify(valoresIniciais) !== JSON.stringify(valoresAtuais);
    }
}
